import React from 'react';
import Layout from '../components/Layout';
import PageMeta from '../components/PageMeta';
import './PolicyPage.css';

const RefundPolicy = () => {
  return (
    <Layout>
      <PageMeta
        title="Return, Cancellation & Refund Policy"
        description="Fmultratech Farms Return, Cancellation, and Refund Policy. Learn about order cancellation, returns, and refund conditions."
      />
      <div className="policy-page">
        <div className="policy-hero">
          <h1>Return, Cancellation, and Refund Policy</h1>
          <p>Fmultratech Farms</p>
        </div>
        <div className="policy-content">
          <div className="policy-container">
            <section className="policy-section">
              <h2>1. Introduction</h2>
              <p>
                This Return, Cancellation, and Refund Policy (“Policy”) governs the conditions under which customers may request cancellations, returns, or refunds for orders placed through the Fmultratech Farms platform (“Company”, “we”, “us”, or “our”). By placing an order, customers (“User”, “Customer”, or “you”) agree to be bound by this Policy.
              </p>
            </section>

            <section className="policy-section">
              <h2>2. Order Cancellation Within Grace Period</h2>
              <h3>2.1</h3>
              <p>
                Customers may request cancellation of an order without providing a reason, provided that:
              </p>
              <ul>
                <li>The order has not yet been submitted to the production company or fulfillment partner; and</li>
                <li>The request is made within twenty-four (24) hours from the time payment is successfully completed (“Grace Period”).</li>
              </ul>
              <h3>2.2</h3>
              <p>
                During the Grace Period, eligible cancellation requests may qualify for a full refund, subject to verification by the Company.
              </p>
              <h3>2.3</h3>
              <p>
                The Company reserves the right to determine whether an order has already been submitted for production or processing.
              </p>
            </section>

            <section className="policy-section">
              <h2>3. Orders Submitted for Production</h2>
              <h3>3.1</h3>
              <p>
                Once an order has been submitted for production, processing, or fulfillment, cancellation, return, or refund requests based solely on change of mind or personal preference will not be accepted.
              </p>
              <h3>3.2</h3>
              <p>
                This restriction exists because production resources, materials, and operational commitments are initiated after submission.
              </p>
            </section>

            <section className="policy-section">
              <h2>4. Damaged, Defective, or Incorrect Items</h2>
              <h3>4.1</h3>
              <p>
                Customers may request a return, replacement, or refund where:
              </p>
              <ul>
                <li>The delivered product is damaged;</li>
                <li>The product is defective; or</li>
                <li>The delivered product materially differs from the confirmed order.</li>
              </ul>
              <h3>4.2</h3>
              <p>
                Customers must notify the Company within a reasonable period after delivery and provide sufficient evidence, which may include photographs, videos, or other documentation.
              </p>
              <h3>4.3</h3>
              <p>
                The Company reserves the right to assess claims and determine eligibility for replacement or refund.
              </p>
            </section>

            <section className="policy-section">
              <h2>5. Special or Exceptional Circumstances</h2>
              <h3>5.1</h3>
              <p>
                The Company may, at its sole discretion, consider refund or return requests outside the standard conditions described in this Policy.
              </p>
              <h3>5.2</h3>
              <p>
                Any such exceptions shall be handled on a case-by-case basis and subject to mutual agreement between the Company and the Customer.
              </p>
            </section>

            <section className="policy-section">
              <h2>6. Refund Processing</h2>
              <h3>6.1</h3>
              <p>
                Approved refunds shall be processed using the original payment method unless otherwise agreed.
              </p>
              <h3>6.2</h3>
              <p>
                Processing times may vary depending on payment providers, financial institutions, or applicable administrative procedures.
              </p>
            </section>

            <section className="policy-section">
              <h2>7. Policy Updates</h2>
              <p>
                The Company reserves the right to modify or update this Policy at any time. Continued use of the platform constitutes acceptance of any updated terms.
              </p>
            </section>

            <section className="policy-section">
              <h2>8. Contact Information</h2>
              <p>
                All cancellation, return, or refund requests must be submitted through the official communication channels provided on the Fmultratech Farms platform.
              </p>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default RefundPolicy;
